import { render } from "./orderDetailsView.vue?vue&type=template&id=0545eb04&scoped=true"
import script from "./orderDetailsView.vue?vue&type=script&lang=js"
export * from "./orderDetailsView.vue?vue&type=script&lang=js"

import "./orderDetailsView.vue?vue&type=style&index=0&id=0545eb04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0545eb04"]])

export default __exports__